import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BazisCoreSharedModule } from '@bazis/shared/core-shared.module';
import { SizeRange } from '@bazis/shared/models/base.types';

@Component({
    selector: 'app-button-tooltip',
    templateUrl: './button-tooltip.component.html',
    imports: [BazisCoreSharedModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonTooltipComponent {
    @Input() icon: string = '';

    @Input() color: string = 'action';

    @Input() fill: string = 'solid';

    // тултип кнопки
    @Input() tooltipKey: string = null;

    // параметры для tooltip
    @Input() tooltipParams: any = null;

    @Input() disabled: boolean = false;

    @Input() size: SizeRange;

    @Output()
    actionClick = new EventEmitter();

    buttonAction() {
        this.actionClick.emit();
    }
}
